import React, { useState, useEffect } from "react";
import { Grid, Divider, Button, Header } from "semantic-ui-react";
import { useNavigate } from "react-router-dom";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import axios from "axios";
import { BaseUrl, BaseUrlInvoice } from "../formcomponents/Constants";
import { decryptData, secretKey } from "../store/Encrypt";
import Cookies from "js-cookie";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { userData } from "../store/userData";
import Swal from "sweetalert2";
const DeDailyEntryDataList = (props) => {
  const navigate = useNavigate();
  const [rowData, setrowData] = useState([]);
  const userDetail = userData();
  const { visaCategoryId } = props;
  const [bankDataList, setBankDataList] = useState([]);
  const [companyDataList, setCompanyDataList] = useState([]);
  const [ticketDataList, setTicketDataList] = useState([]);
  useEffect(() => {
    getDeCompanyList();
    getDeBankList();
    getTicketList();
  }, []);

  useEffect(() => {
    if (companyDataList.length > 0 && bankDataList.length > 0 && ticketDataList.length > 0) {
      getWorkCatList();
    }
  }, [companyDataList, bankDataList,ticketDataList ]); // Runs only when companyDataList is updated
  const getDeCompanyList = async () => {
    try {
      const res = await axios.post(BaseUrl + "listSSVisaCategory", {
        visaTypeNumber: 15965,
      });

      console.log("comppany List", res.data);
      const processData = res.data?.map((item) => ({
        text: item.visaCategory,
        value: item.visaCategoryId,
      }));
      setCompanyDataList(processData);
    } catch (error) {
      console.log(error);
    }
  };

  const getDeBankList = async () => {
    try {
      const res = await axios.post(BaseUrl + "listSSVisaCategory", {
        visaTypeNumber: 42569,
      });
      console.log("Bank List", res.data);
      const processData = res.data?.map((item) => ({
        text: item.visaCategory,
        value: item.visaCategoryId,
      }));
      setBankDataList(processData);
    } catch (error) {
      console.log(error);
    }
  };

  const getTicketList = async () => {
    try {
      const res = await axios.post(BaseUrl + "listSSVisaCategory", {
        visaTypeNumber: 56982,
      });
      console.log("Ticket List", res.data);
      const processData = res.data?.map((item) => ({
        text: item.visaCategory,
        value: item.visaCategoryId,
      }));
      setTicketDataList(processData);
    } catch (error) {
      console.log(error);
    }
  };

  const getWorkCatList = async () => {
    await axios
      .post(BaseUrlInvoice + "/accounts/getDailyEntryList", {
        categoryId: visaCategoryId,
        getAll: visaCategoryId === 0 ? true : false,
     
      })
      .then((res) => {
        console.log("Original data:", res.data);
        const processData = res.data?.map((item) => ({
          dailyEntryId: item.dailyEntryId,
          entryDate: item.entryDate,
          companyName:item.companyName,
          companyNameId: companyNameFormList(item?.companyNameId),
          ticketType: ticketNameFormList(item?.ticketType),
          paymentRecievedBank: bankNameFormList(item?.paymentRecievedBank),
          remarks: item.remarks,
          description: item.description
        }));
        setrowData(processData);
      })
      .catch((error) => console.log(error));
  };

  const companyNameFormList = (id) => {
    const name = companyDataList?.find((item) => item.value === id);
    return name?.text;
  };

  const ticketNameFormList = (id) => {
    const name = ticketDataList?.find((item) => item.value === id);
    return name?.text;
  };

  const bankNameFormList = (id) => {
    const name = bankDataList?.find((item) => item.value === id);
    return name?.text;
  };


  const columnDefs = [
  
    { headerName: "Entry Date", field: "entryDate" },   
    { headerName: "company Name", field: "companyName" },
    { headerName:"Ticket Type", field: "ticketType" },
    { headerName:"Recieved Bank", field: "paymentRecievedBank" },
    { headerName:"Remark", field: "remarks" },
    { headerName:"Description", field: "description" },


    {
      headerName: "Action",
      field: "dailyEntryId",
      cellRendererFramework: (params) => (
        <div>
          <Button color="primary" onClick={() => actionButton(params)}>
            edit
          </Button>{" "}
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          {/* {userDetail.userRole == 1 && (
            <Button color="red" onClick={() => deleteItem(params)}>
              delete
            </Button>
          )} */}
        </div>
      ),
    },
  ];

  const deleteItem = (params) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        // Swal.fire("Deleted!", "Your file has been deleted.", "success");
        axios
          .post(BaseUrl + "deleteSSVisaCategory", {
            visaCategoryId: params.data.visaCategoryId,
          })
          .then((res) => {
            console.log(res.data);
            Swal.fire(
              "Deleted!",
              " Ticket category  has been deleted.",
              "success"
            );
            getWorkCatList();
          })
          .catch((error) => {
            console.log(error);
          });
      }
    });
  };
  const actionButton = (params) => {
    // console.log("Params", params.data);
    navigate(`/daily-entry-data-create/${params.data.dailyEntryId}/${visaCategoryId}`);
  };
  const defaultColDef = {
    sortable: true,
    editable: true,
    flex: 1,
    filter: true,
    floatingFilter: true,
  };


    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";
  
    const exportToCSV = (csvData, fileName) => {
      const ws = XLSX.utils.json_to_sheet(csvData);
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const data = new Blob([excelBuffer], { type: fileType });
      FileSaver.saveAs(data, fileName + fileExtension);
    };
  return (
    <div>
      <Grid.Row>
        <Header dividing size="huge" as="h1">
          Daily Entry Company List
        </Header>
      </Grid.Row>
      <Divider hidden /> <Divider hidden />
      {
        visaCategoryId != 0 &&   <Grid.Row>
        <Button
          type="submit"
          primary
          onClick={() => navigate(`/daily-entry-data-create/null/${visaCategoryId}`)}
        >
          Create New
        </Button>
      </Grid.Row>
      }

           {rowData !== null && (
                  <Button
                    color="primary"
                    onClick={(e) => exportToCSV(rowData, "Invoice_List")}
                  >
                    Download CSV
                  </Button>
                )}
    
      <Divider hidden /> <Divider />
      <div className="ag-theme-alpine" style={{ height: 600 }}>
        <AgGridReact
          rowData={rowData}
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          pagination={true}
        ></AgGridReact>
      </div>
    </div>
  );
};

export default DeDailyEntryDataList;
